import * as TYPES from '@app/store/actionTypes';
import { TemplateAction, templateDataFetched } from '@app/store/template/actions';

type TemplateOriginTitleState = string;

const initialState: TemplateOriginTitleState = '';

export default function reducer(
  state: TemplateOriginTitleState = initialState,
  action: TemplateAction
) {
  switch (action.type) {
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
      return initialState;
    case templateDataFetched.type:
      return action.payload.originalTitle;
    default:
      return state;
  }
}
